<template>
  <div class="container">
    <ul class="number">
      <li v-for="i in 23" :key="i">{{ i }}</li>
    </ul>
    <ul class="col">
      <li v-for="(item, index) in shoes" :key="index">
        <transition-group
          class="row"
          name="staggered-fade"
          tag="ul"
          appear
          v-on:before-appear="beforeAppear"
          v-on:appear="appear"
        >
          <li v-for="i in 23" :key="i" :data-index="i" :class="{active: i <= Number(item)}"></li>
        </transition-group>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from "lodash";
import { TweenLite } from "gsap";

export default {
  name: "RaceBodyComponent",
  computed: {
    shoes() {
      let temp = _.values(this.$store.state.shoes);
      return this.$store.state.section > 5 ? temp.slice(5) : temp.slice(0, 5);
    }
  },
  methods: {
    beforeAppear: function(el) {
      el.style.opacity = 0;
      // TweenLite.set(el, { scale: 0.5 });
    },
    appear: function(el, done) {
      let delay = el.dataset.index * 0.05;
      TweenLite.to(el, 0.5, { scale: 1, opacity: 1, delay: delay });
    }
  }
};
</script>

<style scoped lang="scss">
$space: 0.78em;
$width: vw(80);
.container {
  position: relative;
  display: flex;
}
.number {
  font-size: vw(30);
  width: vw(60);
  > li {
    height: vw(32);
    padding-top: 0.3em;
    line-height: 1;
    margin-bottom: vw(20);
  }
}
.col {
  display: flex;
  > li {
    width: $width;
  }
}
.row {
  > li {
    margin: 0 auto vw(20);
    width: vw(68);
    height: vw(32);
    background-image: url("../assets/img/shose_other.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    &.active {
      background-image: url("../assets/img/shose_nike.svg");
    }
  }
}
</style>
